import React, { memo, useCallback, useMemo } from "react";
import { ContactPictureStepProps } from "./types";
import { FleetDocumentUpload } from "services/api/fleet/vehicles/documents/types";
import FileUploadControl from "ui/components/FileUpload/FileUploadControl/FileUploadControl";
import { useTranslate } from "helpers";

const ContactPictureStep: React.FC<ContactPictureStepProps> = ({ formValues, setFormValues }) => {

  const { t } = useTranslate();
  const handleUploadSave = useCallback(
    (uploads: FleetDocumentUpload[], meta?: { name?: string }) => {
      const files = uploads.map((u) =>
        Object.assign(new File([], u.originalFileName), {
          id: u.id,
          url: u.url,
          isNew: true,
        })
      );

      setFormValues((prev) => ({
        ...prev,
        pictures: [
          ...(prev.pictures || []),
          { name: meta?.name ?? "", files: files as any },
        ],
      }));
    },
    [setFormValues]
  );

  const handlePictureDelete = useCallback(
    (id: string) => {
      setFormValues((prev) => ({
        ...prev,
        pictures: prev.pictures?.map(picture => ({
          ...picture,
          files: picture.files.filter((f) => f.id !== id),
        })).filter(picture => picture.files.length > 0),
      }));
    },
    [setFormValues]
  );

  const uploadFiles: FleetDocumentUpload[] = useMemo(() => {
    return (formValues.pictures ?? []).flatMap(p =>
      p.files.map(f => ({
        id: f.id,
        originalFileName: f.name || p.name,
        fileExtension: f.name?.split(".").pop() ?? "",
        fileSizeKb: Math.round((f.size || 0) / 1024),
        contentType: f.type || "image/jpeg",
        created: new Date(),
        url: f.url ?? "",
        name: p.name,
      }))
    );
  }, [formValues.pictures]);

  return (
    <div className="flex items-center justify-center px-4 mt-8 xl:mt-16 min-h-[60vh] xl:min-h-[600px]">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">Slike {formValues.contactTypeId === "C" ? "tvrtke" : "osobe"}</h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
          Dodajte slike kontakta kao što su profilna fotografija, logo tvrtke ili vizitka.
          Nakon unosa možete nastaviti na sljedeći korak.
        </p>
        <div className="px-3">
          <FileUploadControl
            uploads={uploadFiles}
            onUploadSave={handleUploadSave}
            onUploadDelete={handlePictureDelete}
            emptyText={t("admin.fleet.contact.edit.picture.add.description")}
            buttonText="Dodaj sliku"
            modalTitle="Upload slika"
            showNameField
            nameLabel="Naziv"
            namePlaceholder="npr. Profilna fotografija, Logo, Vizitka"
          />
        </div>
      </div>
    </div>
  );
};

export default memo(ContactPictureStep);
